const UNKNOWN_REASON_LABEL = 'Not available in this region';

const REGION_REASON_LABELS: Record<string, string> = {
  NO_PAYMENT_RAIL: 'No payment rail in this region',
  NO_SMS_ORIGINATION: 'SMS is not available in this region',
  NO_AGGREGATION_PROVIDER: 'Account linking is not available in this region',
  NOT_IN_SCOPE_FOR_REGION: 'Not supported in this region yet',
};

const REGION_ERROR_MESSAGES: Record<string, string> = {
  'region-required': 'Select a region for this template.',
  'region-not-enabled-for-tenant': 'This region is not enabled for your business account.',
  'region-immutable': 'The region of an existing template cannot be changed.',
  'region-not-active': 'This region is not active.',
  'step-not-available-in-region': 'This step is not available in the selected region.',
  'channel-not-available-in-region': 'This channel is not available in the selected region.',
};

// Unknown reasons fall back so a backend that adds a reason code never shows a blank label.
export const getRegionReasonLabel = (reason?: string): string => (reason && REGION_REASON_LABELS[reason]) || UNKNOWN_REASON_LABEL;

export const getRegionErrorMessage = (code?: string): string | undefined => (code ? REGION_ERROR_MESSAGES[code] : undefined);
